import {
  ADD_MEDICINE_TO_CATEGORY,
  ADD_MEDICINE_TO_CATEGORY_FAIL,
  ADD_MEDICINE_TO_CATEGORY_SUCCESS,
  CREATE_MEDICINE_CATEGORY,
  CREATE_MEDICINE_CATEGORY_FAIL,
  CREATE_MEDICINE_CATEGORY_SUCCESS,
  DELETE_MEDICINE_OF_CATEGORY,
  DELETE_MEDICINE_OF_CATEGORY_FAIL,
  DELETE_MEDICINE_OF_CATEGORY_SUCCESS,
  GET_ADDED_MEDICINE,
  GET_ADDED_MEDICINE_FAIL,
  GET_ADDED_MEDICINE_SUCCESS,
  GET_MEDICINE_CATEGORIES,
  GET_MEDICINE_CATEGORIES_FAIL,
  GET_MEDICINE_CATEGORIES_SUCCESS,
  GET_MEDICINE_DETAILS,
  GET_MEDICINE_DETAILS_FAIL,
  GET_MEDICINE_DETAILS_SUCCESS,
  GET_PART_MED_DETAILS,
  GET_PART_MED_DETAILS_FAIL,
  GET_PART_MED_DETAILS_SUCCESS,
  GET_TASK_MED_DETAILS,
  GET_TASK_MED_DETAILS_FAIL,
  GET_TASK_MED_DETAILS_SUCCESS,
  GET_MED_DROP_LIST,
  GET_MED_DROP_LIST_FAIL,
  GET_MED_DROP_LIST_SUCCESS,
  SAVE_PART_MED_DETAILS,
  SAVE_PART_MED_DETAILS_FAIL,
  SAVE_PART_MED_DETAILS_SUCCESS,
  UPDATE_PART_MED_DATA,
  UPDATE_PART_MED_DATA_FAIL,
  UPDATE_PART_MED_DATA_SUCCESS,
  UPDATE_MEDICINE_OF_CATEGORY,
  UPDATE_MEDICINE_OF_CATEGORY_FAIL,
  UPDATE_MEDICINE_OF_CATEGORY_SUCCESS,
  DELETE_MEDICINE_DOC,
  DELETE_MEDICINE_DOC_SUCCESS,
  DELETE_MEDICINE_DOC_FAIL,
  REMOVE_MED_PART_PROFILE,
  REMOVE_MED_PART_PROFILE_SUCCESS,
  REMOVE_MED_PART_PROFILE_FAIL,
  ADD_MED_LIST_PARTICIAPNT,
  ADD_MED_LIST_PARTICIAPNT_SUCCESS,
  ADD_MED_LIST_PARTICIAPNT_FAIL,
  UPDATE_PART_MED_LIST,
  UPDATE_PART_MED_LIST_SUCCESS,
  UPDATE_PART_MED_LIST_FAIL,
  GET_TASK_MED_REPORT,
  GET_TASK_MED_REPORT_SUCCESS,
  GET_TASK_MED_REPORT_FAIL,
  GET_PARTICIPANT_MEDICATION_REPORT,
  GET_PARTICIPANT_MEDICATION_REPORT_SUCCESS,
  GET_PARTICIPANT_MEDICATION_REPORT_FAIL,
  GET_PART_MEDICINE_LOGS,
  GET_PART_MEDICINE_LOGS_SUCCESS,
  GET_PART_MEDICINE_LOGS_FAIL,
  GET_MEDICATION_LOG_SUCCESS,
  GET_MEDICATION_LOG_FAIL,
  GET_MEDICATION_LOG,
} from "./actionTypes";

export const getMedicationLog = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_MEDICATION_LOG,
  payload: { data, onSuccess, onError },
});

export const getMedicationLogSuccess = data => ({
  type: GET_MEDICATION_LOG_SUCCESS,
  payload: data,
});

export const getMedicationLogFail = data => ({
  type: GET_MEDICATION_LOG_FAIL,
  payload: data,
});

export const getPartMedicineLog = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_PART_MEDICINE_LOGS,
  payload: { data, onSuccess, onError },
});

export const getPartMedicineLogSuccess = data => ({
  type: GET_PART_MEDICINE_LOGS_SUCCESS,
  payload: data,
});

export const getPartMedicineLogFail = data => ({
  type: GET_PART_MEDICINE_LOGS_FAIL,
  payload: data,
});

export const getPartMedReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_PARTICIPANT_MEDICATION_REPORT,
  payload: { data, onSuccess, onError },
});

export const getPartMedReportSuccess = data => ({
  type: GET_PARTICIPANT_MEDICATION_REPORT_SUCCESS,
  payload: data,
});

export const getPartMedReportFail = data => ({
  type: GET_PARTICIPANT_MEDICATION_REPORT_FAIL,
  payload: data,
});

export const getTaskMedReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_TASK_MED_REPORT,
  payload: { data, onSuccess, onError },
});

export const getTaskMedReportSuccess = data => ({
  type: GET_TASK_MED_REPORT_SUCCESS,
  payload: data,
});

export const getTaskMedReportFail = data => ({
  type: GET_TASK_MED_REPORT_FAIL,
  payload: data,
});

export const updatePartMedList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_PART_MED_LIST,
  payload: { data, onSuccess, onError },
});

export const updatePartMedListSuccess = data => ({
  type: UPDATE_PART_MED_LIST_SUCCESS,
  payload: data,
});

export const updatePartMedListFail = data => ({
  type: UPDATE_PART_MED_LIST_FAIL,
  payload: data,
});

export const addMedListParticipant = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_MED_LIST_PARTICIAPNT,
  payload: { data, onSuccess, onError },
});

export const addMedListParticipantSuccess = data => ({
  type: ADD_MED_LIST_PARTICIAPNT_SUCCESS,
  payload: data,
});

export const addMedListParticipantFail = data => ({
  type: ADD_MED_LIST_PARTICIAPNT_FAIL,
  payload: data,
});

export const removeMedPartProfile = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REMOVE_MED_PART_PROFILE,
  payload: { data, onSuccess, onError },
});

export const removeMedPartProfileSuccess = data => ({
  type: REMOVE_MED_PART_PROFILE_SUCCESS,
  payload: data,
});

export const removeMedPartProfileFail = data => ({
  type: REMOVE_MED_PART_PROFILE_FAIL,
  payload: data,
});

export const deleteMedDoc = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_MEDICINE_DOC,
  payload: { data, onSuccess, onError },
});

export const deleteMedDocSuccess = data => ({
  type: DELETE_MEDICINE_DOC_SUCCESS,
  payload: data,
});

export const deleteMedDocFail = data => ({
  type: DELETE_MEDICINE_DOC_FAIL,
  payload: data,
});

export const savePartMedDetails = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SAVE_PART_MED_DETAILS,
  payload: { data, onSuccess, onError },
});

export const savePartMedDetailsSuccess = data => ({
  type: SAVE_PART_MED_DETAILS_SUCCESS,
  payload: data,
});

export const savePartMedDetailsFail = data => ({
  type: SAVE_PART_MED_DETAILS_FAIL,
  payload: data,
});

export const getPartMedDetails = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_PART_MED_DETAILS,
  payload: { data, onSuccess, onError },
});

export const getPartMedDetailsSuccess = data => ({
  type: GET_PART_MED_DETAILS_SUCCESS,
  payload: data,
});

export const getPartMedDetailsFail = data => ({
  type: GET_PART_MED_DETAILS_FAIL,
  payload: data,
});

export const getTaskMedDetails = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_TASK_MED_DETAILS,
  payload: { data, onSuccess, onError },
});

export const getTaskMedDetailsSuccess = data => ({
  type: GET_TASK_MED_DETAILS_SUCCESS,
  payload: data,
});

export const getTaskMedDetailsFail = data => ({
  type: GET_TASK_MED_DETAILS_FAIL,
  payload: data,
});

export const medDropList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_MED_DROP_LIST,
  payload: { data, onSuccess, onError },
});

export const medDropListSuccess = data => ({
  type: GET_MED_DROP_LIST_SUCCESS,
  payload: data,
});

export const medDropListFail = data => ({
  type: GET_MED_DROP_LIST_FAIL,
  payload: data,
});

export const getMedicineDetails = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_MEDICINE_DETAILS,
  payload: { data, onSuccess, onError },
});

export const getMedicineDetailsSuccess = data => ({
  type: GET_MEDICINE_DETAILS_SUCCESS,
  payload: data,
});

export const getMedicineDetailsFail = data => ({
  type: GET_MEDICINE_DETAILS_FAIL,
  payload: data,
});

export const updateMedicine = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_MEDICINE_OF_CATEGORY,
  payload: { data, onSuccess, onError },
});

export const updateMedicineSuccess = data => ({
  type: UPDATE_MEDICINE_OF_CATEGORY_SUCCESS,
  payload: data,
});

export const updateMedicineFail = data => ({
  type: UPDATE_MEDICINE_OF_CATEGORY_FAIL,
  payload: data,
});

export const deleteMedicine = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_MEDICINE_OF_CATEGORY,
  payload: { data, onSuccess, onError },
});

export const deleteMedicineSuccess = data => ({
  type: DELETE_MEDICINE_OF_CATEGORY_SUCCESS,
  payload: data,
});

export const deleteMedicineFail = data => ({
  type: DELETE_MEDICINE_OF_CATEGORY_FAIL,
  payload: data,
});

export const addMedicine = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_MEDICINE_TO_CATEGORY,
  payload: { data, onSuccess, onError },
});

export const addMedicineSuccess = data => ({
  type: ADD_MEDICINE_TO_CATEGORY_SUCCESS,
  payload: data,
});

export const addMedicineFail = data => ({
  type: ADD_MEDICINE_TO_CATEGORY_FAIL,
  payload: data,
});

export const getMedicinesList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ADDED_MEDICINE,
  payload: { data, onSuccess, onError },
});

export const getMedicinesListSuccess = data => ({
  type: GET_ADDED_MEDICINE_SUCCESS,
  payload: data,
});

export const getMedicinesListFail = data => ({
  type: GET_ADDED_MEDICINE_FAIL,
  payload: data,
});

export const updatePartMed = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_PART_MED_DATA,
  payload: { data, onSuccess, onError },
});

export const updatePartMedSuccess = data => ({
  type: UPDATE_PART_MED_DATA_SUCCESS,
  payload: data,
});

export const updatePartMedFail = data => ({
  type: UPDATE_PART_MED_DATA_FAIL,
  payload: data,
});

export const createMedicineCategory = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CREATE_MEDICINE_CATEGORY,
  payload: { data, onSuccess, onError },
});

export const createMedicineCategorySuccess = data => ({
  type: CREATE_MEDICINE_CATEGORY_SUCCESS,
  payload: data,
});

export const createMedicineCategoryFail = data => ({
  type: CREATE_MEDICINE_CATEGORY_FAIL,
  payload: data,
});

export const getMedicineCategories = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_MEDICINE_CATEGORIES,
  payload: { data, onSuccess, onError },
});

export const getMedicineCategoriesSuccess = data => ({
  type: GET_MEDICINE_CATEGORIES_SUCCESS,
  payload: data,
});

export const getMedicineCategoriesFail = data => ({
  type: GET_MEDICINE_CATEGORIES_FAIL,
  payload: data,
});
